import {createRouter, createWebHashHistory} from 'vue-router'
import Concept from '../views/CN/Concept'
import Contact from '../views/CN/Contact'
import Enterprise from '../views/CN/Enterprise'
import News from '../views/CN/News'
import Team from '../views/CN/Team'
import Search from '../views/CN/Search'
import Team_partner from "@/components/CN/team/Team_partner"
import Team_manager_adviser from "@/components/CN/team/Team_manager_adviser";
import Team_post_investment_operation from "@/components/CN/team/Team_post_investment_operation";
import Team_manager from '../components/CN/team/Team_manager'
import Team_adviser from "@/components/CN/team/Team_adviser"
import Team_post_investment from "@/components/CN/team/Team_post_investment";
import Team_legal from "@/components/CN/team/Team_legal";
import Team_operation from "@/components/CN/team/Team_operation";
import Index from "@/views/CN/Index";
import Index_en from "@/views/EN/Index_en";
import Concept_en from "@/views/EN/Concept_en";
import Team_en from "@/views/EN/Team_en";
import Team_partner_en from "@/components/EN/team/Team_partner_en";
import Team_manager_adviser_en from "@/components/EN/team/Team_manager_adviser_en";
import Team_manager_en from "@/components/EN/team/Team_manager_en";
import Team_adviser_en from "@/components/EN/team/Team_adviser_en";
import Team_post_investment_operation_en from "@/components/EN/team/Team_post_investment_operation_en";
import Team_post_investment_en from "@/components/EN/team/Team_post_investment_en";
import Team_operation_en from "@/components/EN/team/Team_operation_en";
import Team_legal_en from "@/components/EN/team/Team_legal_en";
import Enterprise_en from "@/views/EN/Enterprise_en";
import News_en from "@/views/EN/News_en";
import Contact_en from "@/views/EN/Contact_en";
import Index_m from '@/views/CN_mobile/Index_m';
import Concept_m from "@/views/CN_mobile/Concept_m";
import Team_m from "@/views/CN_mobile/Team_m";
import Team_partner_m from "@/components/CN_mobile/team/Team_partner_m";
import Team_manager_adviser_m from "@/components/CN_mobile/team/Team_manager_adviser_m";
import Team_manager_m from "@/components/CN_mobile/team/Team_manager_m";
import Team_adviser_m from "@/components/CN_mobile/team/Team_adviser_m";
import Team_post_investment_operation_m from "@/components/CN_mobile/team/Team_post_investment_operation_m";
import Team_post_investment_m from "@/components/CN_mobile/team/Team_post_investment_m";
import Team_legal_m from "@/components/CN_mobile/team/Team_legal_m";
import Team_operation_m from "@/components/CN_mobile/team/Team_operation_m";
import Enterprise_m from "@/views/CN_mobile/Enterprise_m";
import News_m from "@/views/CN_mobile/News_m";
import Contact_m from "@/views/CN_mobile/Contact_m";
import Index_en_m from "@/views/EN_mobile/Index_en_m";
import Concept_en_m from "@/views/EN_mobile/Concept_en_m";
import Enterprise_en_m from "@/views/EN_mobile/Enterprise_en_m";
import News_en_m from "@/views/EN_mobile/News_en_m";
import Contact_en_m from "@/views/EN_mobile/Contact_en_m";
import Team_en_m from "@/views/EN_mobile/Team_en_m";
import Team_partner_en_m from "@/components/EN_mobile/team/Team_partner_en_m";
import Team_manager_adviser_en_m from "@/components/EN_mobile/team/Team_manager_adviser_en_m";
import Team_manager_en_m from "@/components/EN_mobile/team/Team_manager_en_m";
import Team_adviser_en_m from "@/components/EN_mobile/team/Team_adviser_en_m";
import Team_post_investment_operation_en_m from "@/components/EN_mobile/team/Team_post_investment_operation_en_m";
import Team_post_investment_en_m from "@/components/EN_mobile/team/Team_post_investment_en_m";
import Team_legal_en_m from "@/components/EN_mobile/team/Team_legal_en_m";
import Team_operation_en_m from "@/components/EN_mobile/team/Team_operation_en_m";
import test from "@/views/test";
import Search_en from "@/views/EN/Search_en";
import Search_en_m from "@/views/EN_mobile/Search_en_m";
import Search_m from "@/views/CN_mobile/Search_m";

const routes = [
    {
        path: '/',
        redirect: '/index',
    },
    {
        path: '/index',
        name: 'Index',
        component: Index,
        beforeEnter: (to, from, next) => {
            let flag = navigator.userAgent.toLowerCase().match(/(ipod|iphone|webos|android|blackberry)/i) != null
            if (flag) {
                next('/index_m')
            } else {
                next()
            }
        }
    },
    {
        path: '/index_en',
        name: 'Index_en',
        component: Index_en,
    },
    {
        path: '/index_m',
        name: 'Index_m',
        component: Index_m,
    },
    {
        path: '/index_en_m',
        name: 'Index_en_m',
        component: Index_en_m,
    },
    {
        path: '/concept',
        name: 'Concept',
        component: Concept,
    },
    {
        path: '/concept_en',
        name: 'Concept_en',
        component: Concept_en,
    },
    {
        path: '/concept_m',
        name: 'Concept_m',
        component: Concept_m,
    },
    {
        path: '/concept_en_m',
        name: 'Concept_en_m',
        component: Concept_en_m,
    },
    {
        path: '/team',
        name: 'Team',
        component: Team,
        children: [
            {
                path: '',
                redirect: '/team/partner'
            },
            {
                path: 'partner',
                name: 'Team_partner',
                component: Team_partner,
            },
            {
                path: 'manager_adviser',
                name: 'Team_manager_adviser',
                component: Team_manager_adviser,
                children: [
                    {
                        path: '',
                        redirect: '/team/manager_adviser/manager'
                    },
                    {
                        path: 'manager',
                        name: 'Team_manager',
                        component: Team_manager,
                    },
                    {
                        path: 'adviser',
                        name: 'Team_adviser',
                        component: Team_adviser
                    }
                ]
            },
            {
                path: 'post_investment_operation',
                name: 'Team_post_investment_operation',
                component: Team_post_investment_operation,
                children: [
                    {
                        path: '',
                        redirect: '/team/post_investment_operation/post_investment',
                    },
                    {
                        path: 'post_investment',
                        name: 'Team_post_investment',
                        component: Team_post_investment,
                    },
                    {
                        path: 'legal',
                        name: 'Team_legal',
                        component: Team_legal,
                    },
                    {
                        path: 'operation',
                        name: 'Team_operation',
                        component: Team_operation,
                    }

                ]
            }
        ]

    },
    {
        path: '/team_en',
        name: 'Team_en',
        component: Team_en,
        children: [
            {
                path: '',
                redirect: '/team_en/partner'
            },
            {
                path: 'partner',
                name: 'Team_partner_en',
                component: Team_partner_en,
            },
            {
                path: 'manager_adviser',
                name: 'Team_manager_adviser_en',
                component: Team_manager_adviser_en,
                children: [
                    {
                        path: '',
                        redirect: '/team_en/manager_adviser/manager'
                    },
                    {
                        path: 'manager',
                        name: 'Team_manager_en',
                        component: Team_manager_en,
                    },
                    {
                        path: 'adviser',
                        name: 'Team_adviser_en',
                        component: Team_adviser_en,
                    }
                ]
            },
            {
                path: 'post_investment_operation',
                name: 'Team_post_investment_operation_en',
                component: Team_post_investment_operation_en,
                children: [
                    {
                        path: '',
                        redirect: '/team_en/post_investment_operation/post_investment',
                    },
                    {
                        path: 'post_investment',
                        name: 'Team_post_investment_en',
                        component: Team_post_investment_en,
                    },
                    {
                        path: 'legal',
                        name: 'Team_legal_en',
                        component: Team_legal_en,
                    },
                    {
                        path: 'operation',
                        name: 'Team_operation_en',
                        component: Team_operation_en,
                    }

                ]
            }
        ]
    },
    {
        path: '/team_m',
        name: 'Team_m',
        redirect: {'name': 'Team_partner_m'},
        component: Team_m,
        children: [
            {
                path: 'partner',
                name: 'Team_partner_m',
                component: Team_partner_m,
            },
            {
                path: 'manager_adviser',
                name: 'Team_manager_adviser_m',
                component: Team_manager_adviser_m,
                children: [
                    {
                        path: '',
                        redirect: '/team_m/manager_adviser/manager'
                    },
                    {
                        path: 'manager',
                        name: 'Team_manager_m',
                        component: Team_manager_m,
                    },
                    {
                        path: 'adviser',
                        name: 'Team_adviser_m',
                        component: Team_adviser_m,
                    }
                ]
            },
            {
                path: 'post_investment_operation',
                name: 'Team_post_investment_operation_m',
                component: Team_post_investment_operation_m,
                children: [
                    {
                        path: '',
                        redirect: '/team_m/post_investment_operation/post_investment',
                    },
                    {
                        path: 'post_investment',
                        name: 'Team_post_investment_m',
                        component: Team_post_investment_m,
                    },
                    {
                        path: 'legal',
                        name: 'Team_legal_m',
                        component: Team_legal_m,
                    },
                    {
                        path: 'operation',
                        name: 'Team_operation_m',
                        component: Team_operation_m,
                    }
                ]
            }
        ]
    },
    {
        path: '/team_en_m',
        name: 'Team_en_m',
        component: Team_en_m,
        children: [
            {
                path: '',
                redirect: '/team_en_m/partner'
            },
            {
                path: 'partner',
                name: 'Team_partner_en_m',
                component: Team_partner_en_m,
            },
            {
                path: 'manager_adviser',
                name: 'Team_manager_adviser_en_m',
                component: Team_manager_adviser_en_m,
                children: [
                    {
                        path: '',
                        redirect: '/team_en_m/manager_adviser/manager'
                    },
                    {
                        path: 'manager',
                        name: 'Team_manager_en_m',
                        component: Team_manager_en_m,
                    },
                    {
                        path: 'adviser',
                        name: 'Team_adviser_en_m',
                        component: Team_adviser_en_m,
                    }
                ]
            },
            {
                path: 'post_investment_operation',
                name: 'Team_post_investment_operation_en_m',
                component: Team_post_investment_operation_en_m,
                children: [
                    {
                        path: '',
                        redirect: '/team_en_m/post_investment_operation/post_investment',
                    },
                    {
                        path: 'post_investment',
                        name: 'Team_post_investment_en_m',
                        component: Team_post_investment_en_m,
                    },
                    {
                        path: 'legal',
                        name: 'Team_legal_en_m',
                        component: Team_legal_en_m,
                    },
                    {
                        path: 'operation',
                        name: 'Team_operation_en_m',
                        component: Team_operation_en_m,
                    }

                ]
            }
        ]
    },
    {
        path: '/enterprise',
        name: 'Enterprise',
        component: Enterprise,
    },
    {
        path: '/enterprise_en',
        name: 'Enterprise_en',
        component: Enterprise_en,
    },
    {
        path: '/enterprise_m',
        name: 'Enterprise_m',
        component: Enterprise_m,
    },
    {
        path: '/enterprise_en_m',
        name: 'Enterprise_en_m',
        component: Enterprise_en_m,
    },
    {
        path: '/news',
        name: 'News',
        component: News,
    },
    {
        path: '/news_en',
        name: 'News_en',
        component: News_en,
    },
    {
        path: '/news_m',
        name: 'News_m',
        component: News_m,
    },
    {
        path: '/news_en_m',
        name: 'New_en_m',
        component: News_en_m,
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact,
    },
    {
        path: '/contact_en',
        name: 'Contact_en',
        component: Contact_en,
    },
    {
        path: '/contact_m',
        name: 'Contact_m',
        component: Contact_m,
    },
    {
        path: '/contact_en_m',
        name: 'Contact_en_m',
        component: Contact_en_m,
    },
    {
        path: '/search',
        name: 'Search',
        component: Search,
    },
    {
        path: '/search_en',
        name: 'Search_en',
        component: Search_en,
    },
    {
        path: '/search_m',
        name: 'Search_m',
        component: Search_m,
    },
    {
        path: '/search_en_m',
        name: 'Search_en_m',
        component: Search_en_m,
    },
    {
        path: '/test',
        name: 'Test',
        component: test,
    },
]


const router = createRouter({
    history: createWebHashHistory(),
    routes,
    linkActiveClass: 'active',
})


export default router
